module.exports = __webpack_public_path__ + "static/img/9.c1f5fee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/9.png
// module id = viRH
// module chunks = 10